import { STUDENT_ROLE, TUTOR_ROLE } from './global'

import { arrayFromNumber } from '../helpers'

import euroIcon from 'assets/icon/euro-icon.svg'
import bitcoinIcon from 'assets/icon/bitcoin-icon.svg'
import ethereumIcon from 'assets/icon/ethereum-icon.svg'
import tetherIcon from 'assets/icon/tether-icon.svg'

export const getGeneralSettings = (role) => {
  const settings = `/${role}/settings`

  const generalSettings = [
    {
      link: settings,
      label: 'Profile',
      icon: '/assets/image/profile_orange_16x18.svg',
      exact: true,
    },
    {
      link: `${settings}/language`,
      label: 'Language',
      icon: '/assets/image/Language_Orange_20x18.svg',
    },
    {
      link: `${settings}/location`,
      label: 'Location & Time',
      icon: '/assets/image/location-marker.svg',
    },
    {
      link: `${settings}/security`,
      label: 'Security',
      icon: '/assets/image/shield-check.svg',
    },
    {
      link: `${settings}/notifications`,
      label: 'Notifications',
      icon: '/assets/image/bell.svg',
    },
    {
      link: `${settings}/integrations`,
      label: 'Storage Integrations',
      icon: '/assets/image/storage-integrations.svg',
    },
  ]

  if (role === TUTOR_ROLE) {
    generalSettings.push(
      ...[
        {
          link: `${settings}/availability`,
          label: 'Availability',
          icon: '/assets/image/calendar-check-orange.svg',
        },
        {
          link: `${settings}/my-class-categories`,
          label: 'My Class Categories',
          icon: '/assets/image/my-class-cateogires.svg',
        },
        {
          link: `${settings}/my-banners`,
          label: 'My Banners',
          icon: '/assets/image/my-banners.svg',
        },
        {
          link: `${settings}/my-quiz-templates`,
          label: 'My Quiz Templates',
          icon: '/assets/image/my-quiz-templates.svg',
        },
      ]
    )
  }

  if (role === STUDENT_ROLE) {
    generalSettings.push(
      ...[
        {
          link: `${settings}/goals`,
          label: 'Goals & Preferences',
          icon: '/assets/image/target.svg',
        },
      ]
    )
  }

  generalSettings.push({
    link: `${settings}/withdrawing`,
    label: 'Withdrawing',
    icon: '/assets/image/withdrawing.svg',
  })

  return generalSettings
}

export const verificationCodeLength = 4
export const verificationCodeInputs = arrayFromNumber(verificationCodeLength)

export const getNotificationsTabs = (role) => {
  const settings = `/${role}/settings/notifications`

  return [
    {
      link: settings,
      label: 'Email Notification',
      exact: true,
    },
    {
      link: `${settings}/push-notifications`,
      label: 'Push Notification',
    },
  ]
}

export const notificationsSettings = [
  {
    title: 'Classes',
    options: [
      {
        value: 'classesUpdates',
        label:
          'Classes updates (new booking, approved, declined or cancelled, and time change request)',
      },
      {
        value: 'classReminderHourAhead',
        label: 'Class reminders 1 hour ahead',
      },
      {
        value: 'classReminderDayAhead',
        label: 'Class reminders 1 day ahead',
      },
    ],
  },
  {
    title: 'Banners',
    options: [
      {
        value: 'bannersPosted',
        label: 'Class or Job Banners is posted or modified',
      },
      {
        value: 'bannersWillExpire',
        label: 'Job Banners will expire soon',
      },
      {
        value: 'bannersExpired',
        label: 'Job Banners expired',
      },
    ],
  },
  {
    title: 'Messaging',
    options: [
      {
        value: 'messages',
        label: 'User’s Messages',
      },
      {
        value: 'newMessages',
        label: 'New messages from other users',
      },
    ],
  },
  {
    title: 'Personal Updates',
    options: [
      {
        value: 'profileUpdates',
        label: 'My Profile updates',
      },
      {
        value: 'categoryUpdates',
        label: 'My Category updates (category test passed, category test fail)',
      },
      {
        value: 'creditsAchieved',
        label: 'Credits achieved',
      },
      {
        value: 'awardsAchieved',
        label: 'Awards achieved',
      },
    ],
  },
  {
    title: 'Balance/Wallet',
    options: [
      {
        value: 'balanceCreditsAchieved',
        label: 'Credits achieved',
      },
      {
        value: 'balanceWithdrawal',
        label: 'Balance Withdrawal',
      },
    ],
  },
  {
    title: 'Other',
    options: [
      {
        value: 'newsletter',
        label:
          'Newsletter or any helpful resources and important updates related to being a tutor on APOLO P2P',
      },
      {
        value: 'specialOffer',
        label: 'Special offer and any promotional emails',
      },
      {
        value: 'surveys',
        label: 'Surveys and invitations to help us improve APOLO P2P content and your experience',
      },
    ],
  },
]

export const storageServices = [
  {
    icon: '/assets/image/drive.svg',
    name: 'Google Drive',
    connected: true,
  },
  {
    icon: '/assets/image/dropbox.svg',
    name: 'Dropbox',
    connected: false,
  },
  {
    icon: '/assets/image/icedrive.png',
    name: 'IceDrive',
    connected: false,
  },
  {
    icon: '/assets/image/onedrive.svg',
    name: 'OneDrive',
    connected: false,
  },
]

export const reviews = [
  {
    id: '1',
    rate: '5.0',
    date: 'September 15, 2022',
    message:
      '“It was my first time in my early journey of learning about NFTs and their history and  my online tutor was amazing! They were knowledgeable, patient, and made learning enjoyable. Their virtual classroom was user-friendly, and they were flexible with scheduling. Highly recommended!”',
    user: {
      id: '50',
      picture: '/assets/image/upcomingUser1.png',
      first_name: 'Tim',
      last_name: 'Urban',
    },
  },
  {
    id: '2',
    rate: '5.0',
    date: 'September 15, 2022',
    message:
      'Carlos is one of the most patient instructor I have ever worked with in my life, he is so kind and ideal for newcomers like me in the trading world. He is now imparted me with perfect trading strategies that work most of the time!',
    user: {
      id: '50',
      picture: '',
      first_name: 'Tim',
      last_name: 'Urban',
    },
  },
  {
    id: '3',
    rate: '5.0',
    date: 'September 15, 2022',
    message:
      'Carlos is one of the most patient instructor I have ever worked with in my life, he is so kind and ideal for newcomers like me in the trading world. He is now imparted me with perfect trading strategies that work most of the time!',
    user: {
      id: '50',
      picture: '',
      first_name: 'Tim',
      last_name: 'Urban',
    },
  },
  {
    id: '4',
    rate: '5.0',
    date: 'September 15, 2022',
    message:
      'Carlos is one of the most patient instructor I have ever worked with in my life, he is so kind and ideal for newcomers like me in the trading world. He is now imparted me with perfect trading strategies that work most of the time!',
    user: {
      id: '50',
      picture: '',
      first_name: 'Tim',
      last_name: 'Urban',
    },
  },
]

export const hideSettingsTabsRoutes = [
  'test-process',
  'my-banners/add',
  'my-banners/edit',
  'jobs-posts/add',
  'jobs-posts/edit',
  'my-quiz-templates/add',
  'my-quiz-templates/edit',
]

export const hideMyBannersContentRoutes = [
  'my-banners/add',
  'my-banners/edit',
  'jobs-posts/add',
  'jobs-posts/edit',
]

export const withdrawingHistoryTabs = [
  {
    label: 'All Transaction History',
    value: 'all',
  },
  {
    label: 'Euro Transaction History',
    value: 'euro',
  },
]

export const withdrawingHistoryHeadings = ['Date', 'Description', 'Amount', 'Balance']

export const withdrawingHistory = [
  {
    id: 1,
    date: 'Jan 6, 2022',
    description: 'Banner Promotion',
    amount: '- 10,13 USDT',
    balance: '30,40 USDT',
    icon: tetherIcon,
  },
  {
    id: 2,
    date: 'Jan 6, 2022',
    description: 'Banner Renewal',
    amount: '- 0,0014 ETH',
    balance: '0,0235 ETH',
    icon: ethereumIcon,
  },
  {
    id: 3,
    date: 'Jan 6, 2022',
    description: 'Booked Class: Trading',
    amount: '0,00069 BTC',
    balance: '0,0014 BTC',
    icon: bitcoinIcon,
  },
  {
    id: 3,
    date: 'Jan 6, 2022',
    description: 'Booked Class: Metaverse',
    amount: '€ 12.00',
    balance: '€ 106.03',
    icon: euroIcon,
  },
]

export const getMyBannersTabs = (role) => {
  return [
    {
      label: 'Class Banners',
      link: `/${role}/settings/my-banners`,
      exact: true,
    },
    {
      label: 'Jobs Posts',
      link: `/${role}/settings/my-banners/jobs-posts`,
    },
  ]
}
